import Input, { InputOld } from "../ui/input";
import classes from "../ui/dropdown/dropdown.module.css";
import { useEffect, useMemo, useRef, useState } from "react";
import { debounce } from "lodash";
import {
  Autocomplete,
  createFilterOptions,
  createTheme,
  TextField,
} from "@mui/material";
import {
  removeArabicCharacters,
  removeTashkel,
} from "../../pages/NarrationWarehouseLT";

export function InputWithSuggestionAutoCompleteWithDebounceBlur({
  style,
  placeholder,
  className,
  suggestions,
  onChange,
  value,
  parentClassName,
  flag,
  status,
  textArea,
  type,
  getOptionLabel,
}) {
  const filterOptions = createFilterOptions({
    ignoreAccents: true,
    ignoreCase: true,
    stringify: (option) =>
      removeTashkel(removeArabicCharacters(getOptionLabel(option))),
  });

  const [bgColor, setBGColor] = useState("");
  const ref = useRef(false);
  useEffect(() => {
    if (ref?.current?.style?.backgroundColor && flag) {
      ref.current.style.backgroundColor = "var(--primary-color)";
      setTimeout(() => {
        ref.current.style.backgroundColor = "white";
      }, 1000);
    }
  }, [flag]);
  // console.log(flag, status)
  useEffect(() => {
    // console.log(flag, status)
    if (flag) {
      if (status === "isLoading") {
        setBGColor("var(--orange)");
      } else if (status === "success") {
        setBGColor("var( --primary-color-light)");
        setTimeout(() => {
          setBGColor("white");
        }, 1000);
      } else if (status === "error") {
        setBGColor("var(--error-color)");
        setTimeout(() => {
          setBGColor("white");
        }, 1000);
      }
    }
  }, [flag, status]);

  return (
    <div className={`relative ${parentClassName}`} ref={ref}>
      <Autocomplete
        filterOptions={filterOptions}
        disablePortal
        options={suggestions}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              "& .MuiInputBase-root": {
                fontSize: "16px",
                height: "40px",
                borderRadius: "7px",
                fontFamily: "IRANSansWeb",
              },
              backgroundColor: bgColor,
            }}
          />
        )}
        disableClearable
        onChange={(e, newValue) => onChange?.(e, newValue)}
        value={value}
        placeholder={placeholder}
        getOptionLabel={getOptionLabel}
        style={style}
        // className={className}
        // inputValue={value ?? ''}
        // onInputChange={onchange}
      />
    </div>
  );
}
